import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import moment from "moment";
import DatePicker, { registerLocale } from "react-datepicker/es";
import enGB from 'date-fns/locale/en-GB';
import { setHours, setMinutes, toDate } from 'date-fns';
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import withReactContent from "sweetalert2-react-content";
import {
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnItalic,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  HtmlButton,
  Separator,
  Editor,
  EditorProvider,
  Toolbar,
  createButton,
} from 'react-simple-wysiwyg';

import {
  addEvent,
  getEvent,
  getEventMaps,
  getSeasons,
  resetEventsError,
} from "../../../store/actions/eventsActions";
import { currencies } from "../../../constants/currencies";

import { Counter } from "../../../components/Counter/Counter";
import { salesAvailabilityOptions } from "../../../constants/salesAvailabilityOptions";
import { makeElementsReadonly } from "../../../helpers/html";
import { getTimeZoneAsyncFunc, emptyTimeZoneOption } from "../../../helpers/getTimeZoneAsync";
import { getISODateWithTimezoneOffset } from "../../../helpers/date";
import ROUTES from "../../../constants/routes";

import "react-datepicker/dist/react-datepicker.css";
import "./AddEvent.sass";
import { getRegion } from "../../../helpers/getRegion";
import CheckBox from "../../../components/UI/Checkbox/CheckBox";
import { Tooltip } from "../../../components/UI/Tooltip/Tooltip";
import Icon from "../../../components/UI/Icon/Icon";
import NewLoader from "../../../components/NewLoader/NewLoader";

const MySwal = withReactContent(Swal);
const defaultCurrency = currencies.find(c => c.label === getRegion().currency) || {};

class AddEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      startDate: null,
      endDate: null,
      currency: defaultCurrency,
      slug: (Math.random() + 1).toString(32).substring(6),
      isCheckingCovid: false,
      salesAvailability: salesAvailabilityOptions[0],
      activationTime: null,
      maxSeatsToSelectPerTransaction: 4,
      seasonValue: { value: 0, label: "No Season" },
      ticketEmailValue: { value: 0, label: "Default" },
      offerEmailValue: { value: 0, label: "Default" },
      guestEmailValue: { value: 0, label: "Default" },
      errorEmailValue: { value: 0, label: "Default" },
      invoiceEmailValue: { value: 0, label: "Default" },
      qrCodeVisibilityHours: 0,
      timeZoneOption: emptyTimeZoneOption,
      ticketsSoldText: "Tickets sold out",
      salesNotAvailableText: "Sales not available",
      isSeason: false,
      hideForUpcoming: false,
      isRecurring: false,
      maps: [],
      selectedMap: null,
      isLoading: true,
    };
  }

  inputChangeHandler = (event) => {
    let { name, value } = event.target;

    if (name === "fixedFeeRate" || name === "extraFeeRate") {
      if (value[0] === "-") {
        value = "-" + value.replace(/[^\d.]/g, '');
      } else {
        value = value.replace(/[^\d.]/g, '');
      };

      if (name === "extraFeeRate" && (+value > 100 || +value < -100)) {
        return;
      }
    };

    this.setState({ [name]: value });
  };

  handleChange = (type, value) => {
    this.setState({ [type]: value });

    if (type === "startDate" && value) {
      const startDate = moment(value).add(1, "day").toDate();
      this.setState({
        endDate: startDate,
      });
    }
  };

  inputTimeZoneChangeHandle = (value) => {
    this.setState({ timeZoneOption: value, isDisabled: false })
  };

  onTimeZoneMenuOpen = () => {
    setTimeout(()=>{
      const selectedEl = document.getElementsByClassName("custom-select__option--is-selected")[0];
      if(selectedEl){
        selectedEl.scrollIntoView({block: 'nearest',});
      }
    });
  };

  setMaxSeatsToSelectPerTransaction = (value) =>
    this.setState({
      maxSeatsToSelectPerTransaction: value,
    });
  getSeasons = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    return () =>
      this.props.getSeasons(user.token).then((data) => [
        { value: 0, label: "No Season" },
        ...data.map(({ id, seasonName }) => ({
          value: id,
          label: seasonName,
        })),
      ]);
  };

  handleChangeDescription = (e) => {
    this.handleChange('description', e.target.value);
  }

  componentDidMount() {
    // User can't enter text in Start and End date pickers
    makeElementsReadonly("react-datepicker__input-container");
    registerLocale('en-GB', enGB);
    this.props.getEventMaps().then(res => {
      const maps = !!res ? res.map(m => ({ value: m.id, label: m.name })) : [];

      this.setState({ maps, selectedMap: maps[0] })
    }).finally(() => this.setState({ isLoading: false }))
  }

  componentWillUnmount() {
    this.props.resetEventsError();
  }

  addEvent = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const {
      name,
      startDate,
      endDate,
      currency,
      isCheckingCovid,
      slug,
      salesAvailability,
      activationTime,
      place,
      prefixLabel,
      maxSeatsToSelectPerTransaction,
      seasonValue,
      ticketEmailValue,
      offerEmailValue,
      guestEmailValue,
      errorEmailValue,
      invoiceEmailValue,
      qrCodeVisibilityHours,
      fixedFeeRate,
      extraFeeRate,
      isSeason,
      isRecurring,
      selectedMap,
      description,
      ticketsSoldText,
      salesNotAvailableText,
      hideForUpcoming,
    } = this.state;
    const { addEvent, getEvent } = this.props;    

    const isoStartDate = getISODateWithTimezoneOffset(startDate);
    const isoEndDate = getISODateWithTimezoneOffset(endDate);
    const isoActivationTime = activationTime
      ? getISODateWithTimezoneOffset(activationTime)
      : null;

    const data = {
      activationTime: isoActivationTime,
      salesAvailability: salesAvailability.value,
      name,
      slug,
      prefixLabel,
      startDate: isoStartDate,
      endDate: isoEndDate,
      currency: currency.value,
      isCheckingCovid,
      place: place,
      maxSeatsToSelectPerTransaction: maxSeatsToSelectPerTransaction,
      seasonId: seasonValue.value,
      emailTicketTemplateId: ticketEmailValue.value,
      emailOfferTemplateId: offerEmailValue.value,
      emailGuestTemplateId: guestEmailValue.value,
      emailErrorTemplateId: errorEmailValue.value,
      emailInvoiceTemplateId: invoiceEmailValue.value,
      qrCodeVisibilityHours: qrCodeVisibilityHours,
      fixedFeeRate: fixedFeeRate || 0,
      extraFeeRate: (+extraFeeRate / 100) || 0,
      isSeason,
      isRecurring,
      hideForUpcoming,
      seatsIoMapId: selectedMap ? selectedMap.value : null,
      description: description || null,
      ticketsSoldText: ticketsSoldText || null,
      salesNotAvailableText: salesNotAvailableText || null,
    };

    if (data.name.length < 2 || data.name.length > 500) {
      MySwal.fire({
        title: "Error!",
        text: "The field Name must be a string with a minimum length of 2 and a maximum length of 500.",
        showConfirmButton: true,
        confirmButtonText: "Ok",
        type: "error",
        timer: 3000,
      });
    } else if (data.slug.length < 2 || data.slug.length > 30) {
      MySwal.fire({
        title: "Error!",
        text: "The field slug must be a string with a minimum length of 2 and a maximum length of 30.",
        showConfirmButton: true,
        confirmButtonText: "Ok",
        type: "error",
        timer: 3000,
      });
    } else {
      addEvent(data, user.token)
        .then((event) => {
          getEvent(event.id, user.token)
        });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.events.error &&
      this.props.events.error !== prevProps.error
    ) {
      toast.error(String(this.props.events.error));

      this.props.resetEventsError();
    };

    const id = this.props.events.currentEvent.id;

    if (this.props.events.currentEvent.id) {
      this.props.history.push({
        pathname: ROUTES.NEW_EVENT_INFO.replace(":id", id),
      })
    }
  }

  render() {
    const {
      name,
      startDate,
      endDate,
      currency,
      slug,
      place,
      prefixLabel,
      salesAvailability,
      activationTime,
      maxSeatsToSelectPerTransaction,
      seasonValue,
      timeZoneOption,
      fixedFeeRate,
      extraFeeRate,
      maps,
      selectedMap,
      isLoading,
      description,
      ticketsSoldText,
      salesNotAvailableText,
      hideForUpcoming,
    } = this.state;

    const customSelectStyles = {
      control: (base) => ({
        ...base,
        height: "46px",
        "min-height": "46px",
      }),
      placeholder: (base) => ({
        ...base,
        color: "#ABABAB",
      }),
    };

    const BtnFontColor = createButton('Color', '', (val) => {
      document.execCommand('foreColor', false, prompt('HEX Color', '') || undefined);
    });

    return (
      
      <div className="add-event">
        {isLoading && (
          <div className='new-event__loader'>
            <NewLoader />
          </div>
        )}
        <div>
          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Event name</label>
                <input
                  type="text"
                  name="name"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter event name"
                  onChange={this.inputChangeHandler}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Venue</label>
                <input
                  type="text"
                  name="place"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter venue"
                  onChange={this.inputChangeHandler}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Season</label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={this.getSeasons()}
                  value={seasonValue}
                  isSearchable={false}
                  onChange={(value) => this.handleChange("seasonValue", value)}
                  classNamePrefix="custom-select"
                  className="custom-select"
                />
              </div>
            </div>
          </div>

          <div className="add-event__row table">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Start</label>
                <DatePicker
                  selected={startDate}
                  onChange={(event) => {
                    this.handleChange("startDate", event);
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="h:mm a d MMM yyyy "
                  timeCaption="time"
                  placeholderText="Select start date"
                  locale="en-GB"
                  maxDate={endDate ? toDate(endDate) : null}
                  minTime={setHours(setMinutes(new Date(), 0), 0)}
                  maxTime={startDate && endDate && moment(startDate).dayOfYear() ===  moment(endDate).dayOfYear() && moment(startDate).year() ===  moment(endDate).year()
                    ? setHours(setMinutes(new Date(), moment(startDate).minute()), moment(startDate).hour())
                    : setHours(setMinutes(new Date(), 45), 23)
                  }
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>End</label>
                <DatePicker
                  selected={endDate}
                  onChange={(value) => {
                    this.handleChange("endDate", value);
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="h:mm a d MMM yyyy "
                  timeCaption="time"
                  placeholderText="Select end date"
                  locale="en-GB"
                  minDate={startDate ? toDate(startDate) : null}
                  minTime={startDate && endDate && moment(startDate).dayOfYear() ===  moment(endDate).dayOfYear() && moment(startDate).year() ===  moment(endDate).year()
                    ? setHours(setMinutes(new Date(), moment(startDate).minute()), moment(startDate).hour())
                    : setHours(setMinutes(new Date(), 0), 0)
                  }
                  maxTime={setHours(setMinutes(new Date(), 45), 23)}
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>Time Zone</label>

                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={getTimeZoneAsyncFunc()}
                  value={timeZoneOption}
                  onChange={this.inputTimeZoneChangeHandle}
                  classNamePrefix='custom-select'
                  className='custom-select'
                  onMenuOpen={this.onTimeZoneMenuOpen}
                />
              </div>
            </div>
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Currency</label>
                <Select
                  options={currencies}
                  classNamePrefix="custom-select"
                  value={currency}
                  onChange={(value) => {
                    this.handleChange("currency", value);
                  }}
                  className="custom-select"
                  styles={customSelectStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#6071B5",
                      primary25: "#F2F4FE",
                      primary50: "#F2F4FE",
                      primary75: "#F2F4FE",
                    },
                  })}
                  placeholder="Select currency"
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>
                  Slug

                  <Tooltip
                    className="add-event__tooltip add-event__tooltip--color-grey"
                    description="The unique string will be part of the 'Slug' page's web address."
                  >
                    <Icon name="info" />
                  </Tooltip>
                </label>
                <input
                  type="text"
                  name="slug"
                  minLength="3"
                  maxLength="30"
                  value={slug}
                  placeholder="Enter slug"
                  onChange={this.inputChangeHandler}
                />
              </div>
            </div>
          </div>

          <div className="add-event__row add-event__row--width-divider">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Category</label>
                <input
                  type="text"
                  name="prefixLabel"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter event category"
                  onChange={this.inputChangeHandler}
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block add-event__block--checkbox">
                <CheckBox
                  name="hideForUpcoming"
                  id="hideForUpcoming"
                  checked={hideForUpcoming}
                  onChange={(e) => {
                    this.handleChange(
                      "hideForUpcoming",
                      e.target.checked
                    )
                  }}
                >
                  Hide from agenda
                </CheckBox>
              </div>
            </div>
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Sales availability</label>
                <Select
                  options={salesAvailabilityOptions}
                  name="salesAvailability"
                  classNamePrefix="custom-select"
                  value={salesAvailability}
                  defaultValue={salesAvailability}
                  onChange={(value) => {
                    this.handleChange("salesAvailability", value);
                  }}
                  className="custom-select"
                  styles={customSelectStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#6071B5",
                      primary25: "#F2F4FE",
                      primary50: "#F2F4FE",
                      primary75: "#F2F4FE",
                    },
                  })}
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>Sales start time</label>
                <DatePicker
                  selected={activationTime}
                  onChange={(value) => {
                    this.handleChange("activationTime", value);
                  }}
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={15}
                  dateFormat="h:mm a d MMM yyyy "
                  timeCaption="time"
                  placeholderText="Select activation time"
                  locale="en-GB"
                />
              </div>
            </div>
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>
                  Map

                  <Tooltip
                    className="add-event__tooltip add-event__tooltip--color-grey"
                    description="The map can be added once and can't be edited later."
                  >
                    <Icon name="info" />
                  </Tooltip>
                </label>
                <Select
                  isClearable
                  options={maps}
                  classNamePrefix="custom-select"
                  value={selectedMap}
                  onChange={(value) => {
                    this.handleChange("selectedMap", value);
                  }}
                  className="custom-select"
                  styles={customSelectStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#6071B5",
                      primary25: "#F2F4FE",
                      primary50: "#F2F4FE",
                      primary75: "#F2F4FE",
                    },
                  })}
                  placeholder="Select map"
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <Counter
                  label={<>
                    Number of tickets in one transaction
                    <Tooltip
                      className="add-event__tooltip"
                      description="The number will regulate the maximum number of tickets per transaction."
                    >
                      <Icon name="info" />
                    </Tooltip>
                  </>}
                  value={maxSeatsToSelectPerTransaction}
                  onValueChange={this.setMaxSeatsToSelectPerTransaction}
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <Counter
                  min="0"
                  label={<>
                    {this.state.qrCodeVisibilityHours > 0 ? `QR-code will be visible in ${this.state.qrCodeVisibilityHours} hours before event` : "QR-code will be visible any time"}
                    <Tooltip
                      className="add-event__tooltip"
                      description="Selected number will regulate visibility of QR-codes in Apple and Google wallets."
                    >
                      <Icon name="info" />
                    </Tooltip>
                  </>}
                  value={this.state.qrCodeVisibilityHours}
                  onValueChange={(value) =>
                    this.inputChangeHandler(
                      {
                        target: {
                          name: "qrCodeVisibilityHours",
                          value
                        }
                      }
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="add-event__row add-event__row--width-divider">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Fixed fee rate, {currency.label || "select currency"}</label>
              <input
                type="text"
                name="fixedFeeRate"
                value={fixedFeeRate}
                minLength="3"
                maxLength="500"
                placeholder="Enter fixed fee rate"
                onChange={this.inputChangeHandler}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Extra fee rate, %</label>
              <input
                type="text"
                name="extraFeeRate"
                value={extraFeeRate}
                minLength="3"
                maxLength="500"
                placeholder="Enter extra fee rate"
                onChange={this.inputChangeHandler}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block add-event__block--checkbox">

              <CheckBox
                id='is-season-checkbox'
                name='is-season-checkbox'
                onChange={() => this.setState({ ...this.state, isSeason: !this.state.isSeason })}
                checked={this.state.isSeason}
              >
                Is season
              </CheckBox>

              {/* <label htmlFor="is-season-checkbox">Is season</label> */}
            </div>
          </div>

          {/* <div className="add-event__column">
            <div className="add-event__block row">

              <CheckBox
                id='is-reccuring-checkbox'
                name='is-reccuring-checkbox'
                onChange={() => this.setState({ ...this.state, isRecurring: !isRecurring })}
                checked={isRecurring}
              />

              <label htmlFor="is-reccuring-checkbox">Is recurring</label>
            </div>
          </div> */}

        </div>

        <div className="add-event__row add-event__row--width-divider">
          <div className="add-event__column">
            <div className="add-event__block add-event__block--fullWidth">
              <label>Tickets sold text</label>
              <input
                type="text"
                name="ticketsSoldText"
                value={ticketsSoldText}
                placeholder="Enter tickets sold text"
                onChange={this.inputChangeHandler}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block add-event__block--fullWidth">
              <label>Sales not available text</label>
              <input
                type="text"
                name="salesNotAvailableText"
                value={salesNotAvailableText}
                placeholder="Enter sales not available text"
                onChange={this.inputChangeHandler}
              />
            </div>
          </div>
        </div>

        <div className="add-event__block add-event__block--fullWidth">
          <div className="add-event__editor">
            <label>Description</label>
            <EditorProvider>
              <Editor
                value={description}
                onChange={this.handleChangeDescription}
              >
              <Toolbar>
                <BtnUndo />
                <BtnRedo />
                <Separator />
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <BtnStrikeThrough />
                <BtnFontColor />
                <Separator />
                <BtnNumberedList />
                <BtnBulletList />
                <Separator />
                <BtnLink />
                <BtnClearFormatting />
                <HtmlButton />
                <Separator />
                <BtnStyles />
              </Toolbar>
              </Editor>
            </EditorProvider>
          </div>
        </div>

        <div className="page-footer">
          <button
            type="button"
            className="btn-primary"
            onClick={this.addEvent}
            disabled={
              !name ||
              !startDate ||
              !endDate ||
              !salesAvailability ||
              !currency.value ||
              !slug ||
              !place ||
              !prefixLabel ||
              maxSeatsToSelectPerTransaction < 1 ||
              fixedFeeRate === "-" ||
              extraFeeRate === "-"
            }
          >
            Add event
          </button>
        </div>
      </div>
    );
  }
}

AddEvent.propTypes = {};

const mapDispatchToProps = (dispatch) => ({
  addEvent: (data, userToken) => dispatch(addEvent(data, userToken)),
  getEvent: (eventId, token) => dispatch(getEvent(eventId, token)),
  resetEventsError: () => dispatch(resetEventsError()),
  getSeasons: (userToken) => dispatch(getSeasons(userToken)),
  getEventMaps: () => dispatch(getEventMaps()),
});

export default connect(
  ({ events }) => ({ events }),
  mapDispatchToProps
)(AddEvent);
